import { useEffect } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/Layout/AppShell'
import { FileManagerPage } from './pages/FileManagerPage'
import { ToolPage } from './pages/ToolPage'
import { Toaster } from "@/components/ui/toaster"
import { TooltipProvider } from "@/components/ui/tooltip"
import { ErrorBoundary } from './components/ErrorBoundary'
import { useDeviceStore } from './stores/device.store'

function App() {
  const autoConnect = useDeviceStore(state => state.autoConnect)

  useEffect(() => {
    autoConnect()
  }, [autoConnect])

  return (
    <ErrorBoundary>
      <TooltipProvider>
        <HashRouter>
          <Routes>
            <Route element={<AppShell />}>
              <Route index element={<FileManagerPage />} />
              <Route path="tools/:id" element={<ToolPage />} />
            </Route>
          </Routes>
        </HashRouter>
        <Toaster />
      </TooltipProvider>
    </ErrorBoundary>
  )
}

export default App
